export const errorMessage = (message: string) => {
  return `"editor-platform-transport": ${message}`;
};

export const internalErrorMessage = (message: string) => {
  return errorMessage(`[Internal Error] ${message}`);
};
